<template>
  <CHeader position="sticky" class="mb-4">
    <CContainer fluid>
      <CHeaderToggler @click="$store.commit('toggleSidebar')">
        <CIcon icon="cilDoubleRight" />
      </CHeaderToggler>

      <AppBreadcrumb />

       <CHeaderBrand class="mx-auto d-lg-none" to="/">
        <CIcon :icon="logo" height="48" alt="Logo" />
      </CHeaderBrand>

      <CHeaderNav>
        <AppHeaderDropdownAccnt />
      </CHeaderNav>

    </CContainer>

  </CHeader>

</template>

<script>
import AppBreadcrumb from './AppBreadcrumb'
import AppHeaderDropdownAccnt from './AppHeaderDropdownAccnt'
import { logo } from '@/assets/brand/logo'

export default {
  name: 'AppHeader',
  components: {
    AppBreadcrumb,
    AppHeaderDropdownAccnt,

},
  setup() {
    return {
      logo,
    }
  },
}
</script>

<style scoped>

</style>
